import { BreakdownSegment } from '@/components/charts/breakdownAdapter.ts';
import SegmentedBar from '@/components/ui/SegmentedBar.tsx';
import Dot from '@/components/ui/Dot.tsx';
import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { formatPrice } from '@/utils/formatters.ts';
import { barShare } from '@/features/dashboard/tours/types/share.utils.ts';

interface SegmentBreakdownProps {
  segments: BreakdownSegment[];
  /** Mianownik udziałów: kwota oczekiwana albo plan kosztów. */
  total: MoneyValueDto;
}

/** Pasek podziału i legenda pod nim — wspólny środek kart salda i budżetu. */
const SegmentBreakdown = ({ segments, total }: SegmentBreakdownProps) => (
  <>
    <SegmentedBar
      segments={segments.map((segment) => ({
        id: segment.id,
        pct: barShare(segment.amount.amount, total.amount),
        color: segment.color,
      }))}
    />

    <div className="flex flex-col gap-2">
      {segments.map((segment) => (
        <div key={segment.id} className="flex items-baseline gap-2.5">
          <Dot
            size="md"
            className="shrink-0"
            style={{ backgroundColor: segment.color }}
          />
          <span className="text-sm text-neutral-700">{segment.label}</span>
          {segment.note && (
            <span className="text-[13px] text-neutral-400">{segment.note}</span>
          )}
          <span className="ml-auto whitespace-nowrap text-[15px] font-bold tabular-nums text-ink">
            {formatPrice(segment.amount.amount, segment.amount.currency)}
          </span>
        </div>
      ))}
    </div>
  </>
);

export default SegmentBreakdown;
